'use strict';

class CalculateKitBox {
    res_container = document.getElementById('result_list');

    calculate(form) {
        $(form).on('beforeSubmit', (e) => {
            //e.preventDefault();
            ym(73234981, 'reachGoal', 'event_click_calculate_kit_box');
            $(this.res_container).find('.empty_result').slideUp();
            $(this.res_container).find('.result').slideUp();
            $(this.res_container).find('.loader-circle').fadeIn();

            let el = document.getElementById('calculate_block');

            el.scrollIntoView({
                behavior: "smooth"
            });


            let url = '/ajax/calculate-kit-box'
            let data = $(form).serializeArray();
            let callback = (result) => {
                if (result.debug.error) {
                    Swal.fire(
                            'Ошибка расчета',
                            result.debug.error.message,
                            'error'
                            )
                } else {
                    this.pushResult(result);
                }
            };

            data.push({
                name: 'place_count',
                value: this.place_count
            })

            let request = new Ajax({
                url: url,
                data: data,
                callback: callback
            })

            request.ajaxRequest();

            return false;
        });
    }

    pushResult(result) {
        if (result.status) {

            $(this.res_container).find('.loader-circle').fadeOut();

            let list_services = $(this.res_container).find('.list-services')

            $(this.res_container).find('.result').slideDown();

            list_services.empty();

            $(this.res_container).find('#total').html(result.price);

            result.services.forEach(function (service) {
                list_services.append('<li class="service-group">' + service.title + '</li>');

                service.items.forEach(function (item) {
                    list_services.append('<li><span class="left">' + item.name + '</span><span class="right">' + item.value + '₽</span></li>');
                })
            });

            let list_dates = $(this.res_container).find('.list-dates');
            list_dates.empty();

            if (result.mindeliverydate) {
                list_dates.append('<li><span class="left">Расчетная дата доставки</span><span class="right">' + result.mindeliverydate + '</span></li>');
            }

            if (result.mindeliverydays) {
                list_dates.append('<li><span class="left">Минимальный срок доставки</span><span class="right">' + result.mindeliverydays + 'д.</span></li>');
            }

            if (result.maxdeliverydays) {
                list_dates.append('<li><span class="left">Максимальный срок доставки</span><span class="right">' + result.maxdeliverydays + 'д.</span></li>');
            }

        } else {
            $(this.res_container).find('.loader-circle').fadeOut();
            $(this.res_container).find('.empty_result').slideDown();
            swal({
                title: "Расчет недоступен!",
                text: "Воспользуйтесь формой обратной связи для получения стоимости расчета.",
                icon: "warning",
                buttons: ['Закрыть', 'Заказать расчет'],
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    $('#cod-wrong-callback').modal('show');
                } else {
                    swal.close();
                }
            });
            let city_out = $('#meacalckitboxform-city_out_name').val(); //город отправления
            let city_in = $('#meacalckitboxform-city_in_name').val(); //город назначения
            let address = $('#meacalckitboxform-address_to').val();
            let price = $('#meacalckitboxform-price').val();
            let declared_price = $('#meacalckitboxform-declared_price').val();
            let post_type = $('.post_type:checked').closest('label').find('span').html();

            let calc_data = 'Город отправления: ' + city_out + "\n" +
                    'Город назначения: ' + city_in + "\n" +
                    'Адрес доставки: ' + address + "\n" +
                    'Стоимость товаров: ' + price + "\n" +
                    'Объявленная стоимость: ' + declared_price + "\n" +
                    'Тип посылки: ' + post_type + "\n";

            $('#callbackwrongcalculate-calc_data').val(calc_data);
        }
    }
}

